import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import ScrollDirection from "./use-scroll-direction";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "use-scroll-direction"
    }}>{`use-scroll-direction`}</h1>
    <p>{`Hook Description`}</p>
    <Playground __position={0} __code={'<ScrollDirection />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ScrollDirection
    }} style={{
      height: "1000px"
    }} mdxType="Playground">
  <ScrollDirection mdxType="ScrollDirection" />
    </Playground>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";
import { useScrollDirection } from "react-hooks-lab";

const ScrollDirection = () => {
  const scrollingDir = useScrollDirection();

  return <div>Is scrolling (direction): {scrollingDir}</div>;
};
export default ScrollDirection;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      